import { T } from "@transifex/react";
import { Container } from "./styles";

export function Loading() {
  return (
    <Container>
      <div className="loader">
        <T _str="Loading..." />
      </div>
    </Container>
  );
}
